import script from "./SupportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportView.vue?vue&type=script&setup=true&lang=ts"

import "./SupportView.vue?vue&type=style&index=0&id=8e3e7e50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e3e7e50"]])

export default __exports__